import type { NotificationChannelManager } from './NotificationChannelManager.types';

export default {
  addListener: () => {},
  removeListeners: () => {},
} as NotificationChannelManager;
